import React from 'react';

export interface LoadingCardProps {
  lines?: number;
  showAvatar?: boolean;
  lineWidths?: string[];
  className?: string;
}

const LoadingCard: React.FC<LoadingCardProps> = ({
  lines = 3,
  showAvatar = false,
  lineWidths,
  className = '',
}) => {
  const defaultWidths = ['w-3/4', 'w-full', 'w-2/3'];
  const widths = lineWidths && lineWidths.length > 0 ? lineWidths : defaultWidths;

  return (
    <div className={`card animate-pulse ${className}`}>
      <div className={`flex ${showAvatar ? 'items-start gap-4' : 'flex-col'}`}>
        {showAvatar && (
          <div className="h-12 w-12 rounded-full bg-border-light/60 dark:bg-border-dark/60" />
        )}
        <div className="flex-1 space-y-2">
          {Array.from({ length: lines }).map((_, index) => {
            const width = widths[index] || 'w-full';
            const height = index === 0 ? 'h-5' : 'h-4';
            return (
              <div
                key={index}
                className={`${height} ${width} rounded bg-border-light/60 dark:bg-border-dark/60`}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LoadingCard;
